import { useEffect } from 'react';
import ReactOnRails from 'react-on-rails';
import storage from 'redux-persist/lib/storage';

import { resyncFavorites } from './FavoritesConnectors';
import { KEY, REDUX_PERSIST_PREFIX } from '../../../Store';

const useCrossTabShinglesFavoritesResync = () => {
  useEffect(() => {
    const getPersistedShinglesFavorites = async () => {
      const rawData = await storage.getItem(`${REDUX_PERSIST_PREFIX}${KEY}`);
      if (!rawData) {
        return [];
      }
      const data = JSON.parse(rawData);
      const { shinglesFavorites = '{}' } = data;
      const { items = [] } = JSON.parse(shinglesFavorites);
      return items;
    };

    const resyncShinglesFavorites = async () => {
      const persistedShinglesFavorites = await getPersistedShinglesFavorites();
      const store = ReactOnRails.getStore('Store');
      store.dispatch(resyncFavorites(persistedShinglesFavorites));
    };

    const handleVisibilityChange = e => {
      // It only resyncs if tab is not visible and the new value is not the
      // resync action
      if (
        e.key === `${REDUX_PERSIST_PREFIX}${KEY}` &&
        document.visibilityState !== 'visible' &&
        e.newValue.indexOf('favorites_resync') === -1
      ) {
        resyncShinglesFavorites();
      }
    };

    window.addEventListener('storage', handleVisibilityChange);

    return () => window.removeEventListener('storage', handleVisibilityChange);
  }, []);

  return null;
};

export default useCrossTabShinglesFavoritesResync;
